import { request } from '@/utils'
import type { WorkLogDetail } from '@/views/work-log/types'

export default {
  /**
   * 获取当前用户所有模板
   */
  getLogTemplates: () => request.get('/ops/log/template/getTemplateByCurrentUser'),
  /**
   * 获取当前人相关项目-项目
   */
  getProjectList: () => request.get('/project/implemente/log/getLogOfProjectByCurrentUser'),
  getAllProjectList: () => request.get(`/project/project/open/getProjectFormSelectList`),

  getAllLogisticsProjectList: () => request.get(`/project/project/open/getProjectFormSelectListForLogisticsLog`),

  getProjectByCustomerOrg: (customerOrgId: string) =>
    request.get(`/project/project/open/getProjectByCustomerOrg?customerOrg=${customerOrgId}`),
  getrCustomerContactUser: (customerOrgId: string, loginFilter?: boolean) => {
    if (loginFilter) {
      return request.get(`/project/project/open/getrCustomerContactUser?customerOrgId=${customerOrgId}&loginFilter=${loginFilter}`)
    } else {
      return request.get(`/project/project/open/getrCustomerContactUser?customerOrgId=${customerOrgId}`)
    }
  },
  getCustomerCompanySelectDown: () => request.get('/project/project/open/getCustomerCompanySelectDown'),
  /**
   * 获取当前人相关的运维任务
   */
  getOpsTaskList: (projectId?: string) =>
    request.get('/ops/log/userinfo/getAllOpsTaskOfCurrentUser', {
      params: {
        projectId,
      },
    }),
  /**
   * 获取当前人相关的运维机动任务
   */
  getOpsJdTaskList: (projectId?: string) =>
    request.get('/ops/log/userinfo/getAllOpsJDTaskOfCurrentUser', {
      params: {
        projectId,
      },
    }),
  /**
   * 获取当前人相关的客户单位信息
   */
  getCustomerUnitList: (taskId?: string) =>
    request.get('/ops/log/userinfo/getAllCustomerUnitOfCurrentUser', {
      params: {
        taskId,
      },
    }),
  /**
   * 写日志
   */
  saveLog: (data: WorkLogDetail) => request.post('/ops/log/operation/writeLog', data),
  /**
   * 获取所有抄送人
   */
  getCcUserList: () => request.get('/ops/log/userinfo/getCcUserAllList'),
  /**
   * 获取固定抄送人
   */
  getAlwayCcUserList: (templateId: string) =>
    request.post('/ops/log/userinfo/getCcUserInfoList', {
      templateId,
    }),
  /**
   * 根据当前用户查询项目下的所有客户联系人
   */
  getProjCustomerByCurrentUser: () => request.get('/project/project/open/getProjectCustomerContactUserByUser'),
  /**
   * 获取周报合并信息
   */
  getMergeMsgForProjWeekLog: (data: Recordable) => request.post('/ops/log/project_log/getMergeProjWeekWorkLog', data),
  /**
   * 获取销售日志项目情况
   */
  getTagOpenToSelect: (code: string) => request.get(`/project/sys/project/lifecycleTagGroup/getTagOpenToSelect?groupCode=${code}`),
  /**
   * 申领物品信息
   */
  getReceiveProcessOptions: (projectId: string, logId?: string) =>
    request.post(`/data/project/customer/track/queryProduct`, null, {
      params: {
        projectId,
        logId,
      },
    }),
  /**
   * 销售客户联系人
   */
  getSaleCustomerOptions: (projectId: string) =>
    request.get(`/project/project/open/getCustomerContactUserByProjectId?projectId=${projectId}`),
  /**
   * 查询日志选择项目之后 要抄送的销售
   */
  getCcSaleUserOfProject: (projectId: string) => request.get(`/ops/log/userinfo/getCcSaleUserOfProject?projectId=${projectId}`),

  /**
   * 获取项目的实施节点完成情况
   * @param projectId 项目id
   * @returns
   */
  getNodeCompletedInfoByProjectId: (projectId: string) => {
    return request.get(`/project/implemente/node/getNodeCompletedInfoByProjectId/${projectId}`)
  },
  getNodeCompletedInfoByProjectIdDict: (projectId: string) => {
    return request.get(`/project/implemente/node/getNodeCompletedInfoByProjectIdDict/${projectId}`)
  },
  getAllNode: () => {
    return request.get(`/project/implemente/node/getAllNode`)
  },

  getAllNodeDict: () => {
    return request.get(`/project/implemente/node/getAllNodeDict`)
  },
  /**
   * 获取深化设计信息
   * @param projectId 项目id
   * @returns
   */
  getDeepDesign: (projectId: string) => request.get(`/project/implemente/node/getDeepDesign/${projectId}`),

  /**
   * 查询最新的进度信息
   * @param date 项目id
   * @returns
   */
  lastProcess: (date: any) => request.post(`/project/implemente/node/lastProcess`, date),
  findSignByCode: (data: any) => request.post('/ops/attendance/clock/findSignByCode', data),
  getSignInDetail: (id: string) => request.get(`/ops/log/sale_log/getSignInDetail/${id}`),

  // ------------------------费用报销------------------------//
  getAllUserByDeptId: (data: Recordable) => request.post('/ops/attendance/user/getAllUserByDeptId', data),
  getReimbursementRootCategory: () => request.get(`/ops/reimbursement/getReimbursementRootCategory`),
  getReimbursementCategoryByPId: (pId: string) => request.get(`/ops/reimbursement/getReimbursementCategoryByPId?pId=${pId}`),
  getReimbursement: (data: any) => request.post(`/ops/reimbursement/getReimbursement`, data),
  getReimbursementDetail: (id: string) => request.get(`/ops/reimbursement/getReimbursementDetail?id=${id}`),
  saveReimbursement: (data: any) => request.put(`/ops/reimbursement/saveReimbursement`, data),
  saveReimbursementBatch: (data: any) => request.put(`/ops/reimbursement/saveReimbursementBatch`, data),
  approveReimbursement: (data: any) => request.put(`/ops/reimbursement/approveReimbursement`, data),
  delReimbursement: (id: string) => request.delete(`/ops/reimbursement/delReimbursement?id=${id}`),
  getRecognizeResult: (id: string) => request.get(`/ops/reimbursement/getRecognizeResult?id=${id}`),
}
